import { Component, OnInit } from '@angular/core';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlertComponent } from 'app/popup/alert.component';
import { DatePipe } from '@angular/common';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';


@Component({
  selector: 'app-carrier-type',
  templateUrl: './carrier-type.component.html',
  styleUrls: ['./carrier-type.component.css']
})
export class CarrierTypeComponent implements OnInit {

  form;
  cType: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;
  user = { LastName: '' };
  isDup = false;
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  defaultExtras = { id_type_required_ind: 3, display_demog_frame: true, is_local_carrier: true, is_individual: false };
  public isLoading = false;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };

  constructor(private carrierTypeService: CarrierTypeService, public authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,private toastService:ToastNotificationService,
     public utility: UtilityServiceService, private toastr: ToastrService) { }

  ngOnInit() {

    this.initForm();
    this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Carrier Type';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.carrierTypeService.getById(id).subscribe(result => {
          this.cType = result;
          this.isLoading = false;
          (<FormGroup>this.form)
            .setValue({
              id: this.cType.id
              , code: this.cType.code
              , description: this.cType.description
              , group_code: this.cType.group_code
              , sort_order: this.cType.sort_order
              , is_individual: this.cType.is_individual
              , is_NPO: this.cType.is_NPO
              , is_active: this.cType.is_active
              , display_ind: this.cType.display_ind
              , date_created: this.cType.date_created
              , date_modified: this.cType.date_modified
              , user_created: this.cType.user_created
              , user_modified: this.cType.user_modified
              , id_type_required_ind: this.cType.id_type_required_ind
              , display_demog_frame: this.cType.display_demog_frame
              , is_local_carrier: this.cType.is_local_carrier
              , carriers: (this.cType.carriers) ? this.cType.carriers : null
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.cType.date_created, this.cType.user_created, this.cType.date_modified, this.cType.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Carrier Type';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName);
      }



    });
  }


  initForm() {
    this.form = new FormGroup({
      id: new FormControl()
      , code: new FormControl(this.cType.code, Validators.compose([Validators.required, <any>Validators.maxLength(12), Validators.pattern('[\\w\-\\s\\/]+')]))
      , description: new FormControl(this.cType.description, Validators.maxLength(100))
      , group_code: new FormControl(this.cType.group_code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , sort_order: new FormControl(this.cType.sort_code, Validators.required)
      , is_individual: new FormControl()
      , is_NPO: new FormControl()
      , is_active: new FormControl()
      , display_ind: new FormControl(this.cType.display_ind, Validators.required)
      , date_created: new FormControl()
      , date_modified: new FormControl()
      , user_created: new FormControl()
      , user_modified: new FormControl()
      , carriers: new FormControl()
      , id_type_required_ind: new FormControl()
      , display_demog_frame: new FormControl()
      , is_local_carrier: new FormControl()
    });
    this.form.patchValue(this.utility.defaults);
    this.form.patchValue(this.defaultExtras);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {
    if (this.isDup) { return; }
    this.cType = obj;
    this.message = (this.isEdit) ? "Updating Carrier Type" : "Adding a new Carrier Type";
    if (this.isEdit) {
      this.cType.date_modified = new Date().toLocaleString();
      this.cType.user_modified = this.user.LastName;
      this.isLoading = true;
      this.carrierTypeService.update(this.cType).subscribe(result => {
        this.cType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Carrier Type', message: `Carrier Type ${this.cType.code} updated succesfully.`, bold: `${this.cType.code}` });
        this.toastService.success(`Carrier Type ${this.cType.code} updated succesfully.`, 'Update Carrier Type');
        this.navigate();
      });
    } else {
      this.cType.date_modified = this.cType.date_created = new Date().toLocaleString();
      this.cType.user_modified = this.cType.user_created = this.user.LastName;

      this.isLoading = true;
      this.carrierTypeService.add(this.cType).subscribe(result => {
        this.cType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Carrier Type', message: `New Carrier Type ${this.cType.code} added successfully.`, bold: `${this.cType.code}` });
        this.toastService.success(`New Carrier Type ${this.cType.code} added successfully.`, 'New Carrier Type');

        this.navigate();
      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/carrier/type/list');
  }

  onDuplicates(control) {


  }

  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 3) {
        this.carrierTypeService.checkByCode(code.trim()).subscribe((result:any) => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;
        });
      }
    });
  }

  onChangeValue() {

  }

  onSelectChange() {
    console.dir(this.selectedDisplay);
  }



}
